var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"e-teaser-list"},_vm._l((_vm.events),function(event){return _c('teaser-list-item',{key:event.id,attrs:{"an-event":event}},[_vm._t("default",null,{"event":event})],2)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }